/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  AccountsPayableAuditLogActivity,
  ApprovalStepActivity,
  ApprovalStepActivityV2,
  BulkUpdateTransactionsRequest,
  CardDto,
  CommentActivity,
  CompressedResponseField,
  CsvTransactionExportRequest,
  CustomerTransactionDto,
  CustomerTransactionExportErrorDto,
  ExportEventActivity,
  ExportStatusMappingDto,
  ExternalActionActivityV2,
  GetCardsByOrganisationIdParams,
  InfiniteScrollListCustomerTransactionDtoListCustomerTransactionGroupDto,
  InfiniteScrollListCustomerTransactionDtoVoid,
  PaymentActivity,
  PreAccountingFlowRequest,
  StatusChangeActivity,
  SystemActionActivityV2,
  SystemPaymentActionActivityV2,
  TransactionFilterRequest,
  TransactionListSummaryDto,
  TransactionsCount,
  UpdateCustomerTransactionMerchantCategory,
  UpdateExpenseRequirement,
  UpdateInvoiceNumberRequest,
  UpdateNoteRequest,
  UpdateTransactionCostCarrier,
  UpdateTransactionCostCenter,
  UpdateTransactionExportStatus,
  UpdateTransactionSupplierAccount,
  UpdateTransactionVat,
  UserActionActivity,
  UserActionActivityV2,
  UserFieldChangeActivity,
  VerificationStepActivityV2,
  WalletPaymentsFilterRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiActivityController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-activity-controller
   * @name UpdateTransactionVat
   * @request PUT:/api/v1/activities/{flowId}/vat
   */
  updateTransactionVat = (flowId: string, data: UpdateTransactionVat, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/activities/${flowId}/vat`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateTransactionVatPath = '/v1/activities/${flowId}/vat'
  static updateTransactionVatMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name UpdateTransactionSupplierAccount
   * @request PUT:/api/v1/activities/{flowId}/supplier-account
   */
  updateTransactionSupplierAccount = (
    flowId: string,
    data: UpdateTransactionSupplierAccount,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/activities/${flowId}/supplier-account`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateTransactionSupplierAccountPath = '/v1/activities/${flowId}/supplier-account'
  static updateTransactionSupplierAccountMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name UpdateTransactionNote
   * @request PUT:/api/v1/activities/{flowId}/note
   */
  updateTransactionNote = (flowId: string, data: UpdateNoteRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/activities/${flowId}/note`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateTransactionNotePath = '/v1/activities/${flowId}/note'
  static updateTransactionNoteMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name UpdateTransactionInvoiceNumber
   * @request PUT:/api/v1/activities/{flowId}/invoice-number
   */
  updateTransactionInvoiceNumber = (
    flowId: string,
    data: UpdateInvoiceNumberRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/activities/${flowId}/invoice-number`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateTransactionInvoiceNumberPath = '/v1/activities/${flowId}/invoice-number'
  static updateTransactionInvoiceNumberMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name FindTransactionExportStatus
   * @request GET:/api/v1/activities/{flowId}/export-status
   */
  findTransactionExportStatus = (flowId: string, params: RequestParams = {}) =>
    this.http.request<ExportStatusMappingDto, any>({
      path: `/v1/activities/${flowId}/export-status`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findTransactionExportStatusPath = '/v1/activities/${flowId}/export-status'
  static findTransactionExportStatusMethod = 'GET'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name UpdateTransactionExportStatus
   * @request PUT:/api/v1/activities/{flowId}/export-status
   */
  updateTransactionExportStatus = (
    flowId: string,
    data: UpdateTransactionExportStatus,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/activities/${flowId}/export-status`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateTransactionExportStatusPath = '/v1/activities/${flowId}/export-status'
  static updateTransactionExportStatusMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name UpdateTransactionExpenseRequirement
   * @request PUT:/api/v1/activities/{flowId}/expense-requirement
   */
  updateTransactionExpenseRequirement = (
    flowId: string,
    data: UpdateExpenseRequirement,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/activities/${flowId}/expense-requirement`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateTransactionExpenseRequirementPath = '/v1/activities/${flowId}/expense-requirement'
  static updateTransactionExpenseRequirementMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name UpdateTransactionCostCenter
   * @request PUT:/api/v1/activities/{flowId}/cost-center
   */
  updateTransactionCostCenter = (
    flowId: string,
    data: UpdateTransactionCostCenter,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/activities/${flowId}/cost-center`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateTransactionCostCenterPath = '/v1/activities/${flowId}/cost-center'
  static updateTransactionCostCenterMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name UpdateTransactionCostCarrier
   * @request PUT:/api/v1/activities/{flowId}/cost-carrier
   */
  updateTransactionCostCarrier = (
    flowId: string,
    data: UpdateTransactionCostCarrier,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/activities/${flowId}/cost-carrier`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static updateTransactionCostCarrierPath = '/v1/activities/${flowId}/cost-carrier'
  static updateTransactionCostCarrierMethod = 'PUT'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetActivitiesForRole
   * @request POST:/api/v1/activities
   */
  getActivitiesForRole = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<InfiniteScrollListCustomerTransactionDtoVoid, any>({
      path: `/v1/activities`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getActivitiesForRolePath = '/v1/activities'
  static getActivitiesForRoleMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetUserActivities
   * @request POST:/api/v1/activities/user
   */
  getUserActivities = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<InfiniteScrollListCustomerTransactionDtoVoid, any>({
      path: `/v1/activities/user`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getUserActivitiesPath = '/v1/activities/user'
  static getUserActivitiesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetUserActivitiesGrouped
   * @request POST:/api/v1/activities/user/grouped
   * @deprecated
   */
  getUserActivitiesGrouped = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<InfiniteScrollListCustomerTransactionDtoVoid, any>({
      path: `/v1/activities/user/grouped`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getUserActivitiesGroupedPath = '/v1/activities/user/grouped'
  static getUserActivitiesGroupedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetUserActivitiesCount
   * @request POST:/api/v1/activities/user/count
   */
  getUserActivitiesCount = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<number, any>({
      path: `/v1/activities/user/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getUserActivitiesCountPath = '/v1/activities/user/count'
  static getUserActivitiesCountMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetTransactionSummary
   * @request POST:/api/v1/activities/summary
   */
  getTransactionSummary = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<TransactionListSummaryDto, any>({
      path: `/v1/activities/summary`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getTransactionSummaryPath = '/v1/activities/summary'
  static getTransactionSummaryMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name UpsertPreAccountingFlow
   * @request POST:/api/v1/activities/pre-accounting-flows
   */
  upsertPreAccountingFlow = (data: PreAccountingFlowRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/activities/pre-accounting-flows`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static upsertPreAccountingFlowPath = '/v1/activities/pre-accounting-flows'
  static upsertPreAccountingFlowMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetActivities
   * @request POST:/api/v1/activities/organisation
   */
  getActivities = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<InfiniteScrollListCustomerTransactionDtoVoid, any>({
      path: `/v1/activities/organisation`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getActivitiesPath = '/v1/activities/organisation'
  static getActivitiesMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetOrganisationWalletsActivitiesGrouped
   * @request POST:/api/v1/activities/organisation/wallets/grouped
   */
  getOrganisationWalletsActivitiesGrouped = (
    data: WalletPaymentsFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<InfiniteScrollListCustomerTransactionDtoListCustomerTransactionGroupDto, any>(
      {
        path: `/v1/activities/organisation/wallets/grouped`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      },
    )

  static getOrganisationWalletsActivitiesGroupedPath = '/v1/activities/organisation/wallets/grouped'
  static getOrganisationWalletsActivitiesGroupedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name OrganisationWalletPaymentsCsv
   * @request POST:/api/v1/activities/organisation/wallets/download/csv
   */
  organisationWalletPaymentsCsv = (data: WalletPaymentsFilterRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/activities/organisation/wallets/download/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static organisationWalletPaymentsCsvPath = '/v1/activities/organisation/wallets/download/csv'
  static organisationWalletPaymentsCsvMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetOrganisationActivitiesGrouped
   * @request POST:/api/v1/activities/organisation/grouped
   * @deprecated
   */
  getOrganisationActivitiesGrouped = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<InfiniteScrollListCustomerTransactionDtoVoid, any>({
      path: `/v1/activities/organisation/grouped`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getOrganisationActivitiesGroupedPath = '/v1/activities/organisation/grouped'
  static getOrganisationActivitiesGroupedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetOrganisationActivitiesFlowIdsWithoutPagination
   * @request POST:/api/v1/activities/organisation/flow-ids
   * @deprecated
   */
  getOrganisationActivitiesFlowIdsWithoutPagination = (
    data: TransactionFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/v1/activities/organisation/flow-ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getOrganisationActivitiesFlowIdsWithoutPaginationPath =
    '/v1/activities/organisation/flow-ids'
  static getOrganisationActivitiesFlowIdsWithoutPaginationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name StreamExportOrganisationReceiptsGrouped
   * @request POST:/api/v1/activities/organisation/export/receipt-batch
   */
  streamExportOrganisationReceiptsGrouped = (
    data: CsvTransactionExportRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/activities/organisation/export/receipt-batch`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static streamExportOrganisationReceiptsGroupedPath =
    '/v1/activities/organisation/export/receipt-batch'
  static streamExportOrganisationReceiptsGroupedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetOrganisationActivitiesCount
   * @request POST:/api/v1/activities/organisation/count
   * @deprecated
   */
  getOrganisationActivitiesCount = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<number, any>({
      path: `/v1/activities/organisation/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getOrganisationActivitiesCountPath = '/v1/activities/organisation/count'
  static getOrganisationActivitiesCountMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetActivitiesGrouped
   * @request POST:/api/v1/activities/grouped
   * @deprecated
   */
  getActivitiesGrouped = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<InfiniteScrollListCustomerTransactionDtoVoid, any>({
      path: `/v1/activities/grouped`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getActivitiesGroupedPath = '/v1/activities/grouped'
  static getActivitiesGroupedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetActivitiesFlowIdsWithoutPagination
   * @request POST:/api/v1/activities/flow-ids
   */
  getActivitiesFlowIdsWithoutPagination = (
    data: TransactionFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<string[], any>({
      path: `/v1/activities/flow-ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getActivitiesFlowIdsWithoutPaginationPath = '/v1/activities/flow-ids'
  static getActivitiesFlowIdsWithoutPaginationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name StreamDownloadReceiptsGrouped
   * @request POST:/api/v1/activities/download/receipt-batch
   */
  streamDownloadReceiptsGrouped = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/activities/download/receipt-batch`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static streamDownloadReceiptsGroupedPath = '/v1/activities/download/receipt-batch'
  static streamDownloadReceiptsGroupedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name DownloadCsvWithCustomTemplateId
   * @request POST:/api/v1/activities/download/custom/{templateId}
   */
  downloadCsvWithCustomTemplateId = (
    templateId: string,
    data: TransactionFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/activities/download/custom/${templateId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static downloadCsvWithCustomTemplateIdPath = '/v1/activities/download/custom/${templateId}'
  static downloadCsvWithCustomTemplateIdMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetActivitiesCompressed
   * @request POST:/api/v1/activities/compressed
   */
  getActivitiesCompressed = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<CompressedResponseField, any>({
      path: `/v1/activities/compressed`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getActivitiesCompressedPath = '/v1/activities/compressed'
  static getActivitiesCompressedMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name BulkUpdateTransactions
   * @request POST:/api/v1/activities/bulk-update
   */
  bulkUpdateTransactions = (data: BulkUpdateTransactionsRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/activities/bulk-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static bulkUpdateTransactionsPath = '/v1/activities/bulk-update'
  static bulkUpdateTransactionsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetBulkCounts
   * @request POST:/api/v1/activities/bulk-count
   */
  getBulkCounts = (data: TransactionFilterRequest, params: RequestParams = {}) =>
    this.http.request<TransactionsCount, any>({
      path: `/v1/activities/bulk-count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getBulkCountsPath = '/v1/activities/bulk-count'
  static getBulkCountsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name DownloadBalanceMovementCsvWithCustomTemplateId
   * @request POST:/api/v1/activities/balance-movements/download/custom/{templateId}
   */
  downloadBalanceMovementCsvWithCustomTemplateId = (
    templateId: string,
    data: TransactionFilterRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v1/activities/balance-movements/download/custom/${templateId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    })

  static downloadBalanceMovementCsvWithCustomTemplateIdPath =
    '/v1/activities/balance-movements/download/custom/${templateId}'
  static downloadBalanceMovementCsvWithCustomTemplateIdMethod = 'POST'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name UpdateCustomerTransactionActivityMerchantCategory
   * @request PATCH:/api/v1/activities/{flowId}/category
   */
  updateCustomerTransactionActivityMerchantCategory = (
    flowId: string,
    data: UpdateCustomerTransactionMerchantCategory,
    params: RequestParams = {},
  ) =>
    this.http.request<CustomerTransactionDto, any>({
      path: `/v1/activities/${flowId}/category`,
      method: 'PATCH',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateCustomerTransactionActivityMerchantCategoryPath = '/v1/activities/${flowId}/category'
  static updateCustomerTransactionActivityMerchantCategoryMethod = 'PATCH'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetActivity
   * @request GET:/api/v1/activities/{flowId}
   */
  getActivity = (flowId: string, params: RequestParams = {}) =>
    this.http.request<CustomerTransactionDto, any>({
      path: `/v1/activities/${flowId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getActivityPath = '/v1/activities/${flowId}'
  static getActivityMethod = 'GET'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name SearchTransactionExportErrors
   * @request GET:/api/v1/activities/{flowId}/export-errors
   */
  searchTransactionExportErrors = (flowId: string, params: RequestParams = {}) =>
    this.http.request<CustomerTransactionExportErrorDto[], any>({
      path: `/v1/activities/${flowId}/export-errors`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static searchTransactionExportErrorsPath = '/v1/activities/${flowId}/export-errors'
  static searchTransactionExportErrorsMethod = 'GET'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetExpenseActivityLog
   * @request GET:/api/v1/activities/{flowId}/change-log
   */
  getExpenseActivityLog = (flowId: string, params: RequestParams = {}) =>
    this.http.request<
      (
        | AccountsPayableAuditLogActivity
        | ApprovalStepActivity
        | ApprovalStepActivityV2
        | CommentActivity
        | ExportEventActivity
        | ExternalActionActivityV2
        | PaymentActivity
        | StatusChangeActivity
        | SystemActionActivityV2
        | SystemPaymentActionActivityV2
        | UserActionActivity
        | UserActionActivityV2
        | UserFieldChangeActivity
        | VerificationStepActivityV2
      )[],
      any
    >({
      path: `/v1/activities/${flowId}/change-log`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getExpenseActivityLogPath = '/v1/activities/${flowId}/change-log'
  static getExpenseActivityLogMethod = 'GET'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name BalancesByCategory
   * @request GET:/api/v1/activities/spend-by-category
   */
  balancesByCategory = (params: RequestParams = {}) =>
    this.http.request<Record<string, number>, any>({
      path: `/v1/activities/spend-by-category`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static balancesByCategoryPath = '/v1/activities/spend-by-category'
  static balancesByCategoryMethod = 'GET'
  /**
   * No description
   *
   * @tags api-activity-controller
   * @name GetCardsByOrganisationId
   * @request GET:/api/v1/activities/cards
   */
  getCardsByOrganisationId = (query: GetCardsByOrganisationIdParams, params: RequestParams = {}) =>
    this.http.request<CardDto[], any>({
      path: `/v1/activities/cards`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getCardsByOrganisationIdPath = '/v1/activities/cards'
  static getCardsByOrganisationIdMethod = 'GET'
}
